export const DISTRIBUTION_CHANNEL = {
    NONE: "NONE",
    WPP_MEDIA: "WPP_MEDIA",
    CONNECT: "CONNECT",
} as const;
